import { Duck } from '@atc/modular-redux';
import reducer from './reducer';
import creators from './creators';
import selectors from './selectors';
import types from './types';
export default function filtersDuckCreator(_temp) {
  let {
    namespace = '',
    store = 'filters',
    storePath,
    initialState = {},
    ...rest
  } = _temp === void 0 ? {} : _temp;
  return new Duck({
    ...rest,
    consts: {},
    creators,
    initialState: {
      activeExpansions: [],
      breadcrumbs: [],
      errors: {},
      lastTouched: null,
      options: {},
      touched: {},
      values: {},
      visible: false,
      ...initialState
    },
    namespace,
    reducer,
    selectors,
    store,
    storePath,
    types
  });
}